export default class utils{

    /**
     * Create spin
     * @returns 
     */
    btnSpin(elFormSpin: string){
        
        const spin = document.createElement('i');

        spin.setAttribute('id', elFormSpin);
        spin.setAttribute('class', 'fa-solid fa-circle-notch fa-spin tw-ml-1 tw-mt-1');

        return spin;

    }

    /**
     * Alert Box
     * @param elFormAlert 
     * @param message_error_title 
     * @param text 
     * @returns 
     */
    alertBox(
        elFormAlert: string,
        message_error_title: string,
        text: string
    ){

        const alert = document.createElement("div");

        alert.setAttribute('role', 'alert');
        alert.classList.add(elFormAlert, 'flex', 'basis-full', 'w-full', 'items-center', 'p-4', 'mb-4', 'rounded', 'fluid-text-sm', 'text-red-800', 'bg-red-50');
        alert.innerHTML = '<svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>';
        alert.innerHTML += '<div><span class="font-bold">' + message_error_title + '</span> ' + text + '</div>';

        return alert;
        
    }

    /**
     * Success box
     * @param text 
     * @returns 
     */
    successBox(
        elFormSuccess: string,
        text: string
    ){

        const elDiv = document.createElement("div");

        elDiv.setAttribute('id', elFormSuccess);
        elDiv.setAttribute('role', 'alert');
        elDiv.classList.add('flex', 'basis-full', 'w-full', 'p-4', 'mb-4', 'items-center', 'rounded', 'fluid-text-sm', 'bg-green-800', 'text-white');
        elDiv.innerHTML = '<svg aria-hidden="true" class="flex-shrink-0 inline w-5 h-5 mr-2" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clip-rule="evenodd"></path></svg>';
        elDiv.innerHTML += '<span>' + text + '</span>';

        return elDiv;
        
    }

    /**
     * Remove alert box
     * @param elForm 
     * @param elFormAlert 
     */
    removeAlertBox(elForm: string, elFormAlert: string){
        
        const targetModal = document.querySelector(elForm) as HTMLElement | null;

        if(targetModal !== null){
            
            const boxes = Array.from(targetModal.getElementsByClassName(elFormAlert)) as any;

            boxes.forEach((box: HTMLElement) => {

                box.remove();

            });
    
        }

    }

    
}